module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', [_h('div', [_h('div', {
    staticClass: "head_img"
  }, [_h('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.heads.avatar
    }
  })]), " ", _h('div', {
    staticClass: "head_name"
  }, [_h('span', [" " + _vm._s(_vm.heads.name)])]), " ", _vm._m(0)]), " ", _h('div', {
    staticClass: "hello"
  }, [_h('div', {
    staticClass: "score"
  }, [_h('ul', {
    staticClass: "score_date"
  }, [_h('li', [_vm._s(_vm.heads.score_date[0])]), " ", _h('li', [_vm._s(_vm.heads.score_date[1])])]), " ", _h('ul', {
    staticClass: "score_value"
  }, [_h('li', [_vm._s(_vm.heads.score_value[0]) + " ", _h('span', {
    staticClass: "per"
  }, ["分"])]), " ", _h('li', [_vm._s(_vm.heads.score_value[1]) + " ", _h('span', {
    staticClass: "per"
  }, ["分"])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "vs"
  }, [_h('ul', {
    staticClass: "head_vs"
  }, [_h('li', [" 上次的你 "]), " ", _h('li', [" 这次的你 "])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0d599b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 30
// module chunks = 1